import moment from "moment";

const DATE_FORMAT = 'DD-MM-YYYY';
const CONFIG_DATE_FORMAT = 'YYYY-MM-DD';
const TIME_FORMAT = 'HH:mm';

export default {
    getMomentFromString(str){
        return moment(str, DATE_FORMAT);
    },
    getDateFromString(str){
        return this.getMomentFromString(str).toDate();
    },
    getStringifiedDate(jsDate){
        return moment(jsDate).format(DATE_FORMAT);
    },
    getStringifiedDateTimeFromString(str) {
        return moment(str).format(`${DATE_FORMAT} ${TIME_FORMAT}`);
    },

    /**
     * Convert a DD-MM-YYYY formatted date to YYYY-MM-DD
     * 
     * This is a requirement for our backend to properly function for datetimes saved in JSON objects as our backend cannot handle dates formatted as DD-MM-YYYY 
     * @param {String|undefined} str Date formatted as DD-MM-YYYY
     * @return {string|undefined}
     */
    convertInternalToConfigFormat(str) {
        if(!str) {
            return str;
        }

        //Attempt to figure out if our date is already properly formatted
        const dateParts = str.split('-');

        //Is the first part of our date formatted as YYYY?
        if(dateParts.length && dateParts[0].length === 4) {
            return str;
        }
        
        return moment(str, DATE_FORMAT).format(CONFIG_DATE_FORMAT);
    },

    /**
     * Convert a YYYY-MM-DD formatted date to DD-MM-YYYY, if the given date is already formatted as DD-MM-YYYY it will be returned as is
     * 
     * @param {String|undefined} str Date formatted as YYYY-MM-DD
     * @return {String|undefined}
     */
    convertConfigToInternalFormat(str) {
        if(!str) {
            return str;
        }
        
        //Attempt to figure out if our date is already properly formatted
        const dateParts = str.split('-');
        
        //Is the first part of our date formatted as DD?
        if(dateParts.length && dateParts[0].length === 2) {
            return str;
        }
        
        return moment(str, CONFIG_DATE_FORMAT).format(DATE_FORMAT);
    }
}